import styled from "styled-components"

export const NumberField = styled.div `

  display: grid;
  width: 100%;
  margin: 0;

`